import { ReactNode, useCallback, useMemo, useState } from "react";
import type { CheckoutRoute } from "./NavigationContext";
import { NavigationContext } from "./NavigationContext";
import { CheckoutPage } from "../pages/checkout/CheckoutPage";
import { PaymentProcessingPage } from "../pages/payment-status/PaymentProcessingPage";
import { PaymentSuccessPage } from "../pages/payment-status/PaymentSuccessPage";

const renderRoute = (route: CheckoutRoute): ReactNode => {
  switch (route.name) {
    case "processing":
      return (
        <PaymentProcessingPage
          transaction={route.transaction}
          paymentMethodName={route.paymentMethodName}
          paymentMethod={route.paymentMethod ?? null}
          bookingCode={route.bookingCode}
        />
      );
    case "success":
      return (
        <PaymentSuccessPage
          transaction={route.transaction}
          order={route.order}
          paymentMethodName={route.paymentMethodName}
          paymentMethod={route.paymentMethod ?? null}
        />
      );
    case "checkout":
    default:
      return <CheckoutPage />;
  }
};

export const AppRouter = () => {
  const [route, setRoute] = useState<CheckoutRoute>({ name: "checkout" });

  const navigate = useCallback((nextRoute: CheckoutRoute) => {
    setRoute(nextRoute);
  }, []);

  const page = useMemo(() => renderRoute(route), [route]);

  return <NavigationContext.Provider value={{ route, navigate }}>{page}</NavigationContext.Provider>;
};
